import React from 'react';
import withTheme from '@material-ui/styles/withTheme';
import { Grid, Checkbox, FormControlLabel } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import FormSection from '../../../../components/atom/FormSection';
import DatePickerDropdown from '../../../../components/atom/DatePickerDropdown';
import { onlyVendorAutocomplete } from '../../../../autocomplete';
import AutocompleteSelect from '../../../../components/atom/AutocompleteSelect';

function BatchEditForm({ batch, setBatch }) {
    return (
        <Grid className="bg-white" style={{ width: 300 }}>
            <form
                onSubmit={ev => {
                    ev.preventDefault();
                }}
            >
                <Grid container spacing={1}>
                    <FormSection title="Vendor">
                        <Grid item xs={12}>
                            <AutocompleteSelect
                                disableClearable
                                initCall={ids => onlyVendorAutocomplete.init(ids, true)}
                                autocompleteCall={(search, pageSize) =>
                                    onlyVendorAutocomplete.search(search, pageSize, true)
                                }
                                value={batch.vendor_id ?? null}
                                setValue={value => {
                                    setBatch({
                                        ...batch,
                                        vendor_id: value ? value : null
                                    });
                                }}
                            >
                                <TextField required label="Vendor" />
                            </AutocompleteSelect>
                        </Grid>
                        <Grid item container className="golf-picker" justifyContent="center">
                            <Grid item>
                                <p>From</p>
                                <Grid item>
                                    <DatePickerDropdown
                                        date={batch.from || new Date()}
                                        loading={false}
                                        setDate={date => {
                                            setBatch({ ...batch, from: date });
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item container className="golf-picker" justifyContent="center">
                            <Grid item>
                                <p>Through</p>
                                <Grid item>
                                    <DatePickerDropdown
                                        date={batch.to || new Date()}
                                        loading={false}
                                        setDate={date => {
                                            setBatch({ ...batch, to: date });
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </FormSection>
                    <FormSection title="Batch">
                        <Grid item xs={12}>
                            <TextField
                                required
                                label="Batch no"
                                fullWidth
                                type="text"
                                value={batch.batchNo}
                                disabled // this one is automatically generated
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        color="primary"
                                        checked={batch.is_breakage || false}
                                        onChange={e => {
                                            setBatch({
                                                ...batch,
                                                is_breakage: e.target.checked
                                            });
                                        }}
                                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                                    />
                                }
                                label="Batch is breakage"
                            />
                        </Grid>
                        <Grid item container className="golf-picker" justifyContent="center">
                            <Grid item>
                                <p>Batch date</p>
                                <Grid item>
                                    <DatePickerDropdown
                                        date={batch.batch_date}
                                        loading={false}
                                        setDate={date => {
                                            setBatch({ ...batch, batch_date: date });
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </FormSection>
                    <FormSection title="Invoice">
                        <Grid item xs={12}>
                            <TextField
                                label="Invoice no"
                                fullWidth
                                type="text"
                                value={batch.invoice_num || ''}
                                onChange={e => {
                                    setBatch({
                                        ...batch,
                                        invoice_num: e.target.value
                                    });
                                }}
                            />
                        </Grid>
                        <Grid item container className="golf-picker" justifyContent="center">
                            <Grid item>
                                <p>Invoice date</p>
                                <Grid item>
                                    <DatePickerDropdown
                                        date={batch.invoice_date}
                                        loading={false}
                                        setDate={date => {
                                            setBatch({ ...batch, invoice_date: date });
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </FormSection>
                    <FormSection title="Vendor payment">
                        <Grid item xs={12}>
                            <TextField
                                label="Check / Ref no"
                                fullWidth
                                type="text"
                                value={batch.payment_ref || ''}
                                onChange={e => {
                                    setBatch({
                                        ...batch,
                                        payment_ref: e.target.value
                                    });
                                }}
                            />
                        </Grid>
                        <Grid item container className="golf-picker" justifyContent="center">
                            <Grid item>
                                <p>Payment date</p>
                                <Grid item>
                                    <DatePickerDropdown
                                        date={batch.payment_date}
                                        loading={false}
                                        setDate={date => {
                                            setBatch({ ...batch, payment_date: date });
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </FormSection>
                </Grid>
            </form>
        </Grid>
    );
}

export default withTheme(BatchEditForm);
